import type { SVGProps } from "react";

export function Building(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M7 7h2" />
      <path d="M7 11h2" />
      <path d="M7 15h2" />
      <path d="M15 7h2" />
      <path d="M15 11h2" />
      <path d="M15 15h2" />
      <path d="M11 21V9h2v12" />
    </svg>
  );
}
